<template>
  <div id="CustomerTable">
    <b-table
      :data="customerList"
      hoverable
      :striped="true"
      @click="showSelectedCustomerDetail"
    >
      <template slot-scope="props">
        <!-- Created Date -->
        <b-table-column
          field="register_date"
          :label="$t('customer.detail.created_date')"
          >{{ props.row.created.time | dateformatter }}</b-table-column
        >
        <!-- Contact Number -->
        <b-table-column
          field="contact_number"
          :label="$t('customer.detail.contact_number')"
          >{{ props.row.contact_number | tomsisdn }}</b-table-column
        >
        <!-- Msisdn -->
        <b-table-column field="msisdn" :label="$t('customer.detail.msisdn')">{{
          props.row.msisdn | tomsisdn
        }}</b-table-column>
        <!-- IMEI -->
        <b-table-column field="imei" :label="$t('customer.detail.imei')">{{
          props.row.imei
        }}</b-table-column>
        <!-- Site Prefix (Province) -->
        <b-table-column
          field="location"
          :label="$t('customer.detail.site_prefix')"
          >{{ props.row.location.site_prefix }}</b-table-column
        >
        <!-- Tel Type -->
        <b-table-column
          field="pcrf_status"
          :label="$t('customer.detail.telp_type')"
          :centered="true"
        >
          <b-tag v-if="props.row.telp_type === 'T'" type="is-info"
            >Postpaid</b-tag
          >
          <b-tag v-else type="is-pink">
            <p v-if="props.row.telp_type === 'P'">Prepaid</p>
            <p v-else>{{ props.row.telp_type }}</p>
          </b-tag>
        </b-table-column>
        <!-- Customer Status -->
        <b-table-column
          field="customer_status"
          :label="$t('customer.detail.customer_status')"
          :centered="true"
        >
          <span v-if="props.row.status === 'active'" class="tag is-success">{{
            props.row.status
          }}</span>
          <span
            v-else-if="props.row.status === 'closed'"
            class="tag is-danger"
            >{{ props.row.status }}</span
          >
          <span v-else class="tag is-warning">{{ props.row.status }}</span>
        </b-table-column>
        <!-- PCRF Status -->
        <b-table-column
          field="pcrf_status"
          :label="$t('customer.detail.pcrf_status')"
          :centered="true"
        >
          <span
            v-if="props.row.pcrf_status === 'in_area'"
            class="tag is-success"
            >{{ props.row.pcrf_status }}</span
          >
          <span
            v-else-if="props.row.pcrf_status === 'out_area'"
            class="tag is-danger"
            >{{ props.row.pcrf_status }}</span
          >
          <span v-else class="tag is-warning">{{ props.row.pcrf_status }}</span>
        </b-table-column>
      </template>
    </b-table>
  </div>
</template>

<script>
import dayjs from "dayjs";

export default {
  name: "CustomerTable",
  props: ["customers"],
  data() {
    return {
      isShowDetail: false,
      customerList: this.customers
    };
  },
  watch: {
    customers: function(val) {
      if (val) {
        this.customerList = val;
      }
    }
  },
  filters: {
    tomsisdn: function(value) {
      if (!value) return "";
      switch (value.charAt(0)) {
        case "0":
          return "66" + value.substring(1, value.length);
        default:
          return value;
      }
    },
    todecimal: function(value, decimal_place) {
      if (!value) return "";
      return Number(value).toFixed(decimal_place);
    },
    dateformatter: function(value) {
      if (!value) return "";
      return dayjs(value).format("DD/MM/YYYY @ HH:mm");
    }
  },
  methods: {
    removeQueryString: function() {
      this.isShowDetail = false;
      this.$router.replace({ name: "customers" });
    },
    showSelectedCustomerDetail: function(value) {
      this.isShowDetail = true;
      this.$emit("row_selected");
      this.$router.push({
        name: "customers-deatil",
        params: { id: value._id }
      });
    }
  }
};
</script>
